import { actionSet } from './utils'
import { FETCH_PARCEL_SUCCESS, FETCH_PARCEL_ERROR } from 'constants/actionTypes'
import API_URL from 'constants/api'
import Api from 'utils/ApiRequest'

export const fetchParcelList = (token) => async (dispatch) => {
  try {
    const response = await new Api(token, dispatch).get(API_URL.FETCH_PARCEL)

    return dispatch(actionSet(FETCH_PARCEL_SUCCESS, response.data || []))
  } catch (error) {
    return dispatch(actionSet(FETCH_PARCEL_ERROR, error))
  }
}
